module.exports = "/education/components/slingTipComponent-c523bc.html";